import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class Outstanding extends ConsoleApi {
    /**
     *
     */
    protected readonly resource = '/outstanding';

    /**
     * @param accountId
     */
    public get(accountId: string): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri + this.getAccountResource(accountId), {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param outstandingInvoiceId
     */
    public show(accountId: string, outstandingInvoiceId: string): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri + this.getAccountResource(accountId) + '/' + outstandingInvoiceId, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param cardNumber
     * @param expiryYear
     * @param expiryMonth
     * @param cardUsername
     * @param phoneNumber
     * @param emailAddr
     * @param outstandingInvoiceId
     */
    public payment(accountId: string, cardNumber: string, expiryYear: string, expiryMonth: string, cardUsername: string, phoneNumber: string, emailAddr: string, outstandingInvoiceId: string): Promise<AxiosResponse> {
        return this.axios.post(this.requestUri + this.getAccountResource(accountId) + '/' + outstandingInvoiceId, {
            "money": 0,
            "card_number": cardNumber,
            "expiry_year": expiryYear,
            "expiry_month": expiryMonth,
            "card_username": cardUsername,
            "phone_number": phoneNumber,
            "email_addr": emailAddr
        },{
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}